import {
  Alert,
  AlertIcon,
  Avatar,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Table,
  TableContainer,
  Tbody,
  Td,
  Textarea,
  Th,
  Thead,
  Tr,
  Wrap,
  WrapItem,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { getUsers, lateapproval, seeLateLetters } from "../../../Redux/app/action";
import HRSidebar from "../../../Components/HRSidebar";
import Navbar from "../../../Components/Navbar";
import { PaginationOther } from "../../../Components/PaginationOther";

const HRAllLateRequest = () => {
  const InputStyle = {
    borderRadius: "md",
    borderWidth: "2px",
    borderColor: "gray.300",
    py: "2",
    px: "4",
    variant: "unstyled",
  };

  const BoxStyle = {
    position: "absolute",
    top: "-8px",
    left: "8px",
    pointerEvents: "none",
    color: "green",
    fontSize: "sm",
    bg: "white",
    px: "1",
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(seeLateLetters());
  }, [dispatch]);

  const lateLoginData = useSelector((state) => state.AppReducer.lateLogin);
  //console.log("lateletter", latessData);
  const [searchQuery, setSearchQuery] = useState("");
  const [otherPage, setotherPage] = useState(1);
  let otherperPage = 10;
  let othertotalPage = Math.ceil(lateLoginData.length / otherperPage);
  let endother = otherPage * otherperPage;
  let startother = endother - otherperPage;
  let filteredLetters = [...lateLoginData]
    .filter(
      (el) =>
        (el.employee_id &&
          el.employee_id.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.type &&
          el.type.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.message &&
          el.message.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.currentDate &&
          el.currentDate.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.late_status &&
          el.late_status.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.at && el.at.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (el.start_date &&
          el.start_date.toLowerCase().includes(searchQuery.toLowerCase()))
    )
    .reverse();
  let paginationDataLetters = filteredLetters.slice(startother, endother);

  //console.log("reverseletter", filteredLetters);
  // Handling Pagination End Here

  const toast = useToast();
  const handleLetterStatusChange = (letterId) => {
    const payload = {
      late_status: "Approved",
    };

    dispatch(lateapproval(letterId, payload));
    toast({
      position: "top",
      title: "Late Login Approved",
      description: "",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    window.location.reload();
  };

  const handleLetterStatusRejected = (letterId) => {
    const payload = {
      late_status: "Rejected",
    };

    dispatch(lateapproval(letterId, payload));
    toast({
      position: "top",
      title: "Late Login Rejected",
      description: "",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
    window.location.reload();
  };

  const {
    isOpen: isSidebarOpen,
    onOpen: onSidebarOpen,
    onClose: onSidebarClose,
  } = useDisclosure();
  const btnRef = React.useRef();
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState({
    employee_id: "",
    currentDate: "",
    start_date: "",
    at: "",
    message: "",
    late_status: "",
  });
  //console.log("fflate", formData);
  const handleOpenSidebar = (el) => {
    setSelectedItem(el);
    setFormData({
      employee_id: el.employee_id,
      currentDate: el.currentDate,
      start_date: el.start_date,
      at: el.at,
      message: el.message,
      late_status: el.late_status,
    });
  };

  const handleApprove = async (_id) => {
    const payload = {
      late_status: "Approved",
    };
    try {
      await dispatch(lateapproval(selectedItem._id, payload));
      setSelectedItem(null);

      navigate("/hr/lateloginrequest");
      window.location.reload();
      toast({
        position: "top",
        title: "Late Login Approved",
        description: "",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top",
        title: "Error Approving Late Login",
        description: "An error occurred while Approving Late Login.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleReject = async (_id) => {
    const payload = {
      late_status: "Rejected",
    };
    try {
      await dispatch(lateapproval(selectedItem._id, payload));
      setSelectedItem(null);

      navigate("/hr/lateloginrequest");
      window.location.reload();
      toast({
        position: "top",
        title: "Late Login Rejected",
        description: "",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top",
        title: "Error Rejecting Late Login",
        description: "An error occurred while Rejecting Late Login.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  function convertToAMPM(timeString) {
    const [hours, minutes] = timeString.split(":");
    let formattedTime = "";

    // Convert hours to AM/PM format
    const numericHours = parseInt(hours);
    const ampmHours = numericHours % 12 || 12;
    formattedTime += ampmHours.toString();

    // Append minutes
    formattedTime += `:${minutes}`;

    // Determine AM/PM
    const ampm = numericHours < 12 ? "AM" : "PM";
    formattedTime += ` ${ampm}`;

    return formattedTime;
  }

  
  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const users = useSelector((state) => state.AppReducer.users);

  const userPathMap = {};
  users.forEach((user) => {
    userPathMap[user.employee_id] = user.path;
  });

  // Now you can use the map to get the path for each task's employee_id
  paginationDataLetters.forEach((task) => {
    if (userPathMap.hasOwnProperty(task.employee_id)) {
      const path = userPathMap[task.employee_id];
      //console.log(`Employee ID: ${task.employee_id}, Path: ${path}`);
    } else {
      //console.log(`Employee ID: ${task.employee_id}, Path not found.`);
    }
  });
  return (
    <Flex>
      <HRSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />
        <br />
        <br />
        <Heading size={"md"} textAlign={"start"}>
          All Late Login Request
        </Heading>
        <Flex justifyContent={"space-between"}>
          <Breadcrumb
            spacing="8px"
            mt={6}
            mb={6}
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink href="/hr">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem>
              <BreadcrumbLink href="#">Late Login Request</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Flex justifyContent={"space-between"} gap={3}>
            <Input
              htmlSize={20}
              width="auto"
              placeholder="Search"
              focusBorderColor="green.400"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Flex>
        </Flex>
        <Box>
          <TableContainer>
            <Table variant="simple" colorScheme="teal" boxShadow={"md"}>
              <Thead>
                <Tr boxShadow={"md"}>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    Requested By
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    Letter Type
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    Applied On
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    When
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    Login At
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    Status
                  </Th>
                  <Th boxShadow={"md"} style={{ textAlign: "center" }}>
                    View & Action
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {paginationDataLetters.length > 0 &&
                  paginationDataLetters?.map((el) => {
                    const path = userPathMap[el.employee_id];
    
                    return (
                    <Tr key={el._id} boxShadow={"md"}>
                      <Td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Wrap>
                          <WrapItem>
                            <Flex justifyContent={"space-around"} gap={2}>
                            <Avatar
                                size="xs"
                                name={el.employee_id}
                                src={
                                  path
                                    ? `https://project360-backend.onrender.com/${path}`
                                    : `https://project360-backend.onrender.com/${path}`
                                }
                              />
                              <Heading size={"xs"} mt={1}>
                                {el.employee_id}
                              </Heading>
                            </Flex>
                          </WrapItem>
                        </Wrap>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"}>{el.type}</Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"}>
                          {new Date(el.currentDate).toDateString()}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"}>
                          {new Date(el.start_date).toDateString()}
                        </Button>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"}>{convertToAMPM(el.at)}</Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        {el.late_status !== "Approved" ? (
                          <Popover>
                            <PopoverTrigger>
                              <Button
                                disabled={el.late_status === "Approved"}
                                color={
                                  el.late_status === "Rejected"
                                    ? "red"
                                    : el.late_status === "Pending"
                                    ? "blue"
                                    : "green"
                                }
                                size={"xs"}
                              >
                                {el.late_status}
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader>Confirmation!</PopoverHeader>
                              <PopoverBody>
                                Are you sure you want to approve?
                              </PopoverBody>
                              <PopoverFooter
                                display="flex"
                                justifyContent="flex-end"
                                gap={2}
                              >
                                <ButtonGroup size="xs">
                                  <Button
                                    color="red"
                                    _hover={{color:"white", bgColor:"red"}}
                                    onClick={() =>
                                      handleLetterStatusRejected(el._id)
                                    }
                                  >
                                    No
                                  </Button>
                                </ButtonGroup>
                                <ButtonGroup size="xs">
                                  <Button
                                    color="green"
                                    _hover={{color:"white", bgColor:"green"}}
                                    onClick={() =>
                                      handleLetterStatusChange(el._id)
                                    }
                                  >
                                    Yes
                                  </Button>
                                </ButtonGroup>
                              </PopoverFooter>
                            </PopoverContent>
                          </Popover>
                        ) : (
                          <Button
                            color={
                              el.late_status === "Rejected"
                                ? "red"
                                : el.late_status === "Pending"
                                ? "blue"
                                : "green"
                            }
                            disabled
                            size={"xs"}
                          >
                            {el.late_status}
                          </Button>
                        )}
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          ref={btnRef}
                          onClick={() => {
                            onSidebarOpen();
                            handleOpenSidebar(el);
                          }}
                          size={"xs"}
                        >
                          View
                        </Button>
                      </Td>
                    </Tr>
                  )
                        })}
              </Tbody>
            </Table>
            {selectedItem && (
              <Box>
                <Drawer
                  isOpen={isSidebarOpen}
                  onClose={onSidebarClose}
                  placement="right"
                  finalFocusRef={btnRef}
                  size={"sm"}
                >
                  <form>
                    <DrawerOverlay />
                    <DrawerContent>
                      <DrawerCloseButton />
                      <DrawerHeader>Late Letter Request</DrawerHeader>
                      <DrawerBody>
                        <Box position="relative">
                          <Input
                            {...InputStyle}
                            type="text"
                            defaultValue={formData.employee_id}
                          />
                          <Box {...BoxStyle}>Requested By</Box>
                        </Box>
                        <br />
                        <Box position="relative">
                          <Input
                            {...InputStyle}
                            defaultValue={new Date(
                              formData.currentDate
                            ).toDateString()}
                          />
                          <Box {...BoxStyle}>Applied On</Box>
                        </Box>
                        <br />
                        <Box position="relative">
                          <Input
                            {...InputStyle}
                            defaultValue={new Date(
                              formData.start_date
                            ).toDateString()}
                          />
                          <Box {...BoxStyle}>Start Date</Box>
                        </Box>
                        <br />
                        <Box position="relative">
                          <Input
                            {...InputStyle}
                            defaultValue={convertToAMPM(formData.at)}
                          />
                          <Box {...BoxStyle}>Login At</Box>
                        </Box>
                        <br />
                        <Box position="relative">
                          <Textarea
                            {...InputStyle}
                            height={"200px"}
                            defaultValue={formData.message}
                          />
                          <Box {...BoxStyle}>Message</Box>
                        </Box>
                      </DrawerBody>
                      <DrawerFooter>
                        <Flex justifyContent={"flex-end"} gap={2}>
                          <Button
                            color="red"
                            onClick={handleReject}
                            size={"xs"}
                            _hover={{ bgColor: "red", color: "white" }}
                          >
                            Reject
                          </Button>
                          <Button
                            color="green"
                            onClick={handleApprove}
                            size={"xs"}
                            _hover={{ bgColor: "green", color: "white" }}
                          >
                            Approve
                          </Button>
                        </Flex>
                      </DrawerFooter>
                    </DrawerContent>
                  </form>
                </Drawer>
              </Box>
            )}
            <Box>
              {paginationDataLetters.length === 0 && (
                <Alert
                  status="info"
                  variant="subtle"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  mt={4}
                >
                  <AlertIcon boxSize={8} />
                  No Record Found
                </Alert>
              )}
            </Box>
          </TableContainer>
          <Flex justifyContent={"flex-end"} mt={5}>
            <PaginationOther
              otherPage={otherPage}
              setotherPage={setotherPage}
              othertotalPage={othertotalPage}
            />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default HRAllLateRequest;
